// Article registry — the single list of all articles.
// Each entry drives: the route, the /articles listing card, and (at build time)
// the prerendered page's <head> SEO meta.
//
// To add an article:
//   1. cp src/views/ArticleTemplate.vue src/views/articles/<Slug>.vue  (edit content)
//   2. import it below and add an entry here.
//   3. Fill title/description/date/author/ogImage — canonical/OG use the prod host.
//
// `slug` becomes /articles/<slug>. `noindex: true` keeps a page out of the
// listing, the sitemap, and search (used for the template demo).
import ArticleTemplate from '../views/ArticleTemplate.vue'
import EyejackWebarLaunch from '../views/articles/EyejackWebarLaunch.vue'

const articles = [
  {
    slug: 'eyejack-creator-webar-8th-wall-alternative',
    title: 'EyeJack Creator Launches WebAR Platform | 8th Wall Alternative',
    cardTitle: 'EyeJack Creator now has WebAR',
    description: 'EyeJack Creator now supports WebAR publishing for artists, educators, museums and cultural organisations seeking an alternative to 8th Wall.',
    category: 'News',
    // Drives datePublished/dateModified (JSON-LD) + article:published_time.
    // Keep in sync with the byline in views/articles/EyejackWebarLaunch.vue and
    // the <lastmod> in creator-web/public/sitemap.xml.
    date: '2026-07-10',
    author: 'EyeJack',
    // 1200x630 JPG (not WebP — LinkedIn/Slack scrapers render it inconsistently).
    ogImage: '/landing/eyejack-creator-webar-8th-wall-alternative-og.jpg',
    // Listing/teaser thumbnail. Path is relative to landing/public/ — the card
    // resolves it against the build's publicPath. Use a small variant: the card
    // is never wider than ~380px, so the 2500w original would be ~6x oversized.
    thumbnail: 'eyejack-creator-webar-8th-wall-alternative-800.webp',
    thumbnailAlt: 'A tablet held up to a geometric street mural, showing the artwork lifting off the wall in 3D',
    excerpt: 'Following the closure of 8th Wall, EyeJack Creator now offers no-code WebAR publishing for artists, museums, educators and brands.',
    component: EyejackWebarLaunch
  },
  {
    slug: '_template',
    title: 'Article Template — Component Reference',
    cardTitle: 'Article template & component reference',
    description: 'The standard layout and components every EyeJack Creator article is built from.',
    category: 'Template',
    date: '2026-01-01',
    author: 'EyeJack',
    ogImage: '/landing/social-card.jpg',
    excerpt: 'The standardized layout every article is built from.',
    noindex: true,
    component: ArticleTemplate
  }
]

export default articles

// Articles shown in the listing + sitemap (everything not noindexed), newest first.
export const publishedArticles = articles
  .filter((a) => !a.noindex)
  .sort((a, b) => (a.date < b.date ? 1 : -1))
